import { api } from '../api';

// Interfaces específicas para o frontend
export interface Disponibilidade {
  id?: number;
  cod_empresa: number;
  usuario_id: number;
  dia_semana: number; // PADRÃO JAVASCRIPT: 0=Domingo, 1=Segunda, 2=Terça, 3=Quarta, 4=Quinta, 5=Sexta, 6=Sábado
  hora_inicio: string; // Format: HH:MM
  hora_fim: string; // Format: HH:MM
  tipo: 'trabalho' | 'intervalo'; // 'trabalho' = horário disponível, 'intervalo' = pausa/almoço
  intervalo_minutos: number;
  ativo: boolean;
  observacoes?: string;
  created_at?: string;
  updated_at?: string;
  usuario_nome?: string; // Nome do usuário (join)
}

export interface DisponibilidadeInput {
  usuario_id: number;
  dia_semana: number;
  hora_inicio: string;
  hora_fim: string;
  tipo: 'trabalho' | 'intervalo';
  intervalo_minutos: number;
  ativo: boolean;
  observacoes?: string;
}

export interface DisponibilidadeUpdate {
  dia_semana?: number;
  hora_inicio?: string;
  hora_fim?: string;
  tipo?: 'trabalho' | 'intervalo';
  intervalo_minutos?: number;
  ativo?: boolean;
  observacoes?: string;
}

export interface ResultadoOperacao {
  sucesso: boolean;
  mensagem: string;
  dados?: any;
  erro?: string;
}

export class DisponibilidadesService {
  
  // Listar disponibilidades (opcionalmente filtradas por usuário)
  static async listar(usuarioId?: number): Promise<ResultadoOperacao> {
    // console.log('[DisponibilidadesService] Listando disponibilidades:', {
      // usuarioId,
      // timestamp: new Date().toISOString()
    // });

    try {
      const params = usuarioId ? { usuario_id: usuarioId } : {};
      const response = await api.get('/disponibilidades', { params });

      // console.log('[DisponibilidadesService] Disponibilidades listadas:', {
        // total: response.data.dados?.length || 0,
        // sucesso: response.data.sucesso,
        // timestamp: new Date().toISOString()
      // });

      return response.data;

    } catch (error: any) {
      console.error('[DisponibilidadesService] Erro ao listar disponibilidades:', {
        error: error.response?.data || error.message,
        usuarioId,
        timestamp: new Date().toISOString()
      });

      return {
        sucesso: false,
        mensagem: 'Erro ao listar disponibilidades',
        erro: error.response?.data?.mensagem || error.message
      };
    }
  }

  // Buscar disponibilidade por ID
  static async buscarPorId(id: number): Promise<ResultadoOperacao> {
    // console.log('[DisponibilidadesService] Buscando disponibilidade por ID:', {
      // id,
      // timestamp: new Date().toISOString()
    // });

    try {
      const response = await api.get(`/disponibilidades/${id}`);

      // console.log('[DisponibilidadesService] Disponibilidade encontrada:', {
        // id,
        // sucesso: response.data.sucesso,
        // timestamp: new Date().toISOString()
      // });

      return response.data;

    } catch (error: any) {
      console.error('[DisponibilidadesService] Erro ao buscar disponibilidade:', {
        error: error.response?.data || error.message,
        id,
        timestamp: new Date().toISOString()
      });

      return {
        sucesso: false,
        mensagem: 'Erro ao buscar disponibilidade',
        erro: error.response?.data?.mensagem || error.message
      };
    }
  }

  // Criar nova disponibilidade
  static async criar(dados: DisponibilidadeInput): Promise<ResultadoOperacao> {
    // console.log('[DisponibilidadesService] Criando nova disponibilidade:', {
      // dados,
      // timestamp: new Date().toISOString()
    // });

    try {
      const response = await api.post('/disponibilidades', dados);

      // console.log('[DisponibilidadesService] Disponibilidade criada:', {
        // id: response.data.dados?.id,
        // sucesso: response.data.sucesso,
        // timestamp: new Date().toISOString()
      // });

      return response.data;

    } catch (error: any) {
      console.error('[DisponibilidadesService] Erro ao criar disponibilidade:', {
        error: error.response?.data || error.message,
        dados,
        timestamp: new Date().toISOString()
      });

      return {
        sucesso: false,
        mensagem: 'Erro ao criar disponibilidade',
        erro: error.response?.data?.mensagem || error.message
      };
    }
  }

  // Atualizar disponibilidade
  static async atualizar(id: number, dados: DisponibilidadeUpdate): Promise<ResultadoOperacao> {
    // console.log('[DisponibilidadesService] Atualizando disponibilidade:', {
      // id,
      // dados,
      // timestamp: new Date().toISOString()
    // });

    try {
      const response = await api.put(`/disponibilidades/${id}`, dados);

      // console.log('[DisponibilidadesService] Disponibilidade atualizada:', {
        // id,
        // sucesso: response.data.sucesso,
        // timestamp: new Date().toISOString()
      // });

      return response.data;

    } catch (error: any) {
      console.error('[DisponibilidadesService] Erro ao atualizar disponibilidade:', {
        error: error.response?.data || error.message,
        id,
        dados,
        timestamp: new Date().toISOString()
      });

      return {
        sucesso: false,
        mensagem: 'Erro ao atualizar disponibilidade',
        erro: error.response?.data?.mensagem || error.message
      };
    }
  }

  // Excluir disponibilidade
  static async excluir(id: number): Promise<ResultadoOperacao> {
    // console.log('[DisponibilidadesService] Excluindo disponibilidade:', {
      // id,
      // timestamp: new Date().toISOString()
    // });

    try {
      const response = await api.delete(`/disponibilidades/${id}`);

      // console.log('[DisponibilidadesService] Disponibilidade excluída:', {
        // id,
        // sucesso: response.data.sucesso,
        // timestamp: new Date().toISOString()
      // });

      return response.data;

    } catch (error: any) {
      console.error('[DisponibilidadesService] Erro ao excluir disponibilidade:', {
        error: error.response?.data || error.message,
        id,
        timestamp: new Date().toISOString()
      });

      return {
        sucesso: false,
        mensagem: 'Erro ao excluir disponibilidade',
        erro: error.response?.data?.mensagem || error.message
      };
    }
  }

  // Utilitários
  static getNomeDiaSemana(dia: number): string {
    const dias = [
      'Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira',
      'Quinta-feira', 'Sexta-feira', 'Sábado'
    ];
    return dias[dia] || 'Dia inválido';
  }

  static formatarHorario(inicio: string, fim: string): string {
    return `${inicio} - ${fim}`;
  }

  static validarHorario(inicio: string, fim: string): { valido: boolean; erro?: string } {
    const timeRegex = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/;
    
    if (!timeRegex.test(inicio)) {
      return { valido: false, erro: 'Horário de início inválido (formato: HH:MM)' };
    }
    
    if (!timeRegex.test(fim)) {
      return { valido: false, erro: 'Horário de fim inválido (formato: HH:MM)' };
    }

    // Verificar se fim é posterior ao início
    const [horaIni, minIni] = inicio.split(':').map(Number);
    const [horaFim, minFim] = fim.split(':').map(Number);
    
    const totalMinIni = horaIni * 60 + minIni;
    const totalMinFim = horaFim * 60 + minFim;
    
    if (totalMinFim <= totalMinIni) {
      return { valido: false, erro: 'Horário de fim deve ser posterior ao horário de início' };
    }

    return { valido: true };
  }

  // Configurar estrutura da tabela para suportar intervalos
  static async configurarTabelaIntervalos(): Promise<ResultadoOperacao> {
    try {
      // console.log('[DisponibilidadesService] Configurando tabela para suportar intervalos...');
      
      const response = await api.post('/disponibilidades/setup-tipo-column');
      
      if (response.data.sucesso) {
        // console.log('[DisponibilidadesService] Tabela configurada com sucesso:', response.data.mensagem);
      } else {
        console.error('[DisponibilidadesService] Erro na configuração:', response.data.mensagem);
      }
      
      return response.data;
      
    } catch (error) {
      console.error('[DisponibilidadesService] Erro ao configurar tabela:', error);
      return {
        sucesso: false,
        mensagem: 'Erro ao configurar tabela para intervalos',
        erro: error instanceof Error ? error.message : 'Erro desconhecido'
      };
    }
  }

  // Criar intervalo (registro de tipo 'intervalo')
  static async criarIntervalo(dadosIntervalo: {
    usuario_id: number;
    dia_semana: number;
    hora_inicio: string;
    hora_fim: string;
    observacoes?: string;
  }): Promise<ResultadoOperacao> {
    try {
      // console.log('[DisponibilidadesService] Criando intervalo:', dadosIntervalo);
      
      const intervaloPadrao: DisponibilidadeInput = {
        ...dadosIntervalo,
        tipo: 'intervalo',
        intervalo_minutos: 60, // Padrão para intervalos
        ativo: true
      };
      
      return await this.criar(intervaloPadrao);
      
    } catch (error) {
      console.error('[DisponibilidadesService] Erro ao criar intervalo:', error);
      return {
        sucesso: false,
        mensagem: 'Erro ao criar intervalo',
        erro: error instanceof Error ? error.message : 'Erro desconhecido'
      };
    }
  }
}

export const disponibilidadesService = DisponibilidadesService;
